<template>
    <div class="card">
        <div class="card-header">Preise exportieren</div>
        <div class="card-body">
            <b-button
                variant="success"
                :disabled="articlesForExport.length === 0"
                @click="exportPrices()"
            >
                Preise exportieren
            </b-button>
            <p>
                Eine Liste aller Exporte gibt es
                <router-link to="/export">hier</router-link>
                .
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Export",
    props: {
        articles: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        isConsolidateModus() {
            return this.$store.state.navSelection.isConsolidateModus;
        },
        articlesForExport() {
            // Only Export Articles, where a price is set
            return this.articles.filter(article => article.priceNew);
        }
    },
    methods: {
        exportPrices: function() {
            const priceList = this.articlesForExport.map(item =>
                (({ pzn, priceNew }) => ({ pzn, priceNew }))(item)
            );

            let id = {};
            if (this.isConsolidateModus) {
                id.pharmacyGroupId = this.$store.state.navSelection.pharmacyGroup.id;
            } else {
                id.pharmacyId = this.$store.state.navSelection.pharmacy.id;
            }

            this.$store
                .dispatch("addToExports", {
                    ...id,
                    prices: priceList
                })
                .then(response => {
                    console.log(response);
                    this.$router.push("Export");
                });
        }
    }
};
</script>

<style scoped>
.card-body > * {
    margin: 2px;
}

.card-body {
    display: flex;
    flex-direction: column;
}
</style>
